"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GreatmindsLogo_exports = {};
__export(GreatmindsLogo_exports, {
  default: () => GreatmindsLogo_default
});
module.exports = __toCommonJS(GreatmindsLogo_exports);
var import_jsx_runtime = require("react/jsx-runtime");
const svgContent = (props, title, titleId, desc, descId) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
  "svg",
  __spreadProps(__spreadValues({}, props), {
    viewBox: "0 0 135 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    children: [
      desc ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("desc", { id: descId, children: desc }) : null,
      title ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("rect", { width: 135, height: 24, fill: "currentColor" }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.2664 8C14.6135 8 15.7004 9.2995 16.0585 10.3706L14.3011 10.9449C14.1742 10.4681 13.6307 9.60267 12.2664 9.60267C11.1566 9.60267 9.85005 10.2952 9.85005 12.0053C9.85005 13.608 10.9833 14.4407 12.3127 14.4407C13.665 14.4407 14.232 13.6187 14.3361 13.186H11.8734V11.7349H16.0471V15.8377H14.5672L14.4516 15.0584C14.0929 15.5459 13.3191 16 12.1508 16C9.87287 16 8 14.4307 8 12.0053C8 9.59132 9.95346 8 12.2664 8ZM123.855 8C125.902 8 126.676 9.14791 126.85 10.0461L125.208 10.4795C125.15 10.1222 124.838 9.51586 123.843 9.51586C123.161 9.51586 122.722 9.91653 122.722 10.3386C122.722 10.7072 122.965 10.977 123.531 11.0745L124.63 11.2694C126.191 11.5406 127 12.4821 127 13.5753C127 14.7766 125.924 16 123.97 16C121.704 16 120.733 14.625 120.618 13.5426L122.294 13.1639C122.363 13.8678 122.872 14.4848 123.994 14.4848C124.711 14.4848 125.15 14.1603 125.15 13.6841C125.15 13.2942 124.814 13.0124 124.271 12.9149L123.15 12.7205C121.762 12.4708 120.919 11.6053 120.919 10.4681C120.919 9.0177 122.282 8 123.855 8ZM24.7025 8.16294C26.3207 8.16294 27.362 9.202 27.362 10.5663C27.362 11.6053 26.7487 12.3953 25.7431 12.7312L27.4084 15.8377H25.3964L23.928 12.9803H23.2804V15.8377H21.4531V8.16294H24.7025ZM37.7063 8.16294V9.77563H34.3414V11.2374H37.3946V12.7419H34.3414V14.2144H37.7177V15.8377H32.5149V8.16294H37.7063ZM47.4929 8.16294L50.5454 15.8377H48.557L47.9672 14.2791H44.7991L44.2093 15.8377H42.2901L45.3775 8.16294H47.4929ZM60.6023 8.16294V9.79699H58.0697V15.8377H56.2439V9.79699H53.7234V8.16294H60.6023ZM76.4732 8.16294L78.7276 13.3482L80.8665 8.16294H83.3755V15.8377H81.584V10.7506L79.4444 15.8377H77.9645L75.8256 10.8154V15.8377H74.0911V8.16294H76.4732ZM90.8071 8.16227V15.8377H88.9571V8.16227H90.8071ZM98.5732 8.16294L101.648 12.8287V8.16294H103.475V15.8377H101.545L98.1688 10.7927V15.8377H96.3537V8.16294H98.5732ZM112.017 8.16294C114.48 8.16294 116.133 9.63473 116.133 12.0053C116.133 14.3766 114.48 15.8377 112.005 15.8377H109.045V8.16294H112.017ZM111.931 9.62372H110.872V14.3026H111.931C113.184 14.3026 114.207 13.5844 114.207 11.9681C114.207 10.3525 113.184 9.62372 111.931 9.62372ZM46.406 10.0198L45.4003 12.8086H47.3895L46.406 10.0198ZM24.3191 9.67324H23.2436V11.6321H24.3191C25.0701 11.6321 25.4752 11.2214 25.4752 10.652C25.4752 10.0489 25.0701 9.67324 24.3191 9.67324Z",
          fill: "white"
        }
      )
    ]
  })
);
const SvgIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    desc,
    descId,
    iconSize,
    ariaHidden,
    color
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "desc",
    "descId",
    "iconSize",
    "ariaHidden",
    "color"
  ]);
  const sizes = {
    s: "12px",
    m: "16px",
    l: "24px",
    inherit: "inherit"
    // inherits size from parent
  };
  const size = sizes[iconSize] || "inherit";
  const style = {
    width: size,
    height: size,
    display: "flex",
    color
    // Use the color prop for the icon color
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "div",
    __spreadProps(__spreadValues({
      style,
      "aria-hidden": ariaHidden,
      id: descId ? descId : titleId
    }, props), {
      children: svgContent(props, title, titleId, desc, descId)
    })
  );
};
const SvgGreatmindsLogo = SvgIcon;
var GreatmindsLogo_default = SvgGreatmindsLogo;
//# sourceMappingURL=GreatmindsLogo.js.map